<template>
    <div>
        <Modal title="My Cohorts Management" width="push-40" section="showCohortsDialog">
            <template>
                <div class="row d-flex justify-content-end">
                    <div class="btn-toolbar mt-5" role="toolbar" aria-label="Actions">
                        <a @click="cohortActions()" class="btn btn-info ml-1 text-white  float-right" data-toggle="tooltip" title="Cohort Actions"><i class="fas fa-ellipsis-v"></i> Actions</a>
                    </div><!--btn-toolbar-->
                    <div class="btn-toolbar mt-5" role="toolbar" aria-label="Create">
                        <a @click="createNewCohort()" class="btn btn-success ml-1 text-white  float-right" data-toggle="tooltip" title="Create New Cohort"><i class="fas fa-plus-circle"></i> Create</a>
                    </div><!--btn-toolbar-->
                </div>
            </template>
            <div class="row mt-4 mb-4 d-flex justify-content-between">
                <div class="col-12">
                    <div class="table-responsive">
                        <TableLoading v-if="loading" cols="4"></TableLoading>
                        <table class="table" v-if="!loading">
                            <thead>
                            <tr style="border-bottom: 2px solid lightgray">
                                <td><strong>ID</strong></td>
                                <td><strong>Name</strong></td>
                                <td style="min-width: 100px !important;"><strong>Total EIDs</strong></td>
                                <td style="min-width: 100px !important;"><strong>Total IPs</strong></td>
                                <td style="min-width: 150px !important;"><strong>Status</strong></td>
                                <td><strong>Details</strong></td>
                                <td><strong>Actions</strong></td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="cohort in cohorts" :key="cohort.id">
                                <td>{{ cohort.id }}</td>
                                <td v-if="editing_cohort.id === cohort.id">
                                    <div class="d-flex justify-content-between">
                                        <v-text-field
                                            dense
                                            class="my-0 py-0"
                                            v-model="editing_cohort.name"
                                        ></v-text-field>
                                        <i @click="updateCohortName(cohort.name)" class="fas fa-check ml-2 pt-2 text-success" role="button"></i>
                                        <i @click="cancelUpdateCohortName()" class="fas fa-times ml-2 pt-2 text-danger" role="button"></i>
                                    </div>
                                </td>
                                <td v-if="editing_cohort.id !== cohort.id">
                                    {{ cohort.name }}
                                    <i v-if="cohort.isEditable" @click="editCohortField(cohort)" class="fas fa-edit ml-2 text-warning" role="button"></i>
                                </td>
                                <td>
                                    <span v-if="cohort.status === 4 && cohort.total_eids != null">{{ new Intl.NumberFormat().format(cohort.total_eids) }}</span>
                                    <span v-else></span>
                                </td>
                                <td>
                                    <span v-if="cohort.status === 4 && cohort.total_ips != null">{{ new Intl.NumberFormat().format(cohort.total_ips) }}</span>
                                    <span v-else></span>
                                </td>
                                <td>
                                  <v-progress-linear
                                      v-if="cohort.status === 4"
                                      color="success"
                                      height="10"
                                      value="100"
                                      rounded
                                  ></v-progress-linear>

                                  <v-progress-linear
                                      v-else-if="cohort.status > 4"
                                      color="error"
                                      height="10"
                                      value="100"
                                      rounded
                                  ></v-progress-linear>

                                  <v-progress-linear
                                      v-else
                                      color="info"
                                      height="10"
                                      indeterminate
                                      rounded
                                  ></v-progress-linear>

                                  <span class="mt-1 d-block">{{ cohort.status_string }}</span>
                                </td>
                                <td>
                                    <div v-if="cohort.identifier"><strong>Base Identifier: </strong>{{ cohort.identifier }}</div>
                                    <div v-if="cohort.details">
                                        <ul class="list-unstyled mb-0">
                                            <li v-if="cohort.details.type === 'campaign'"><strong>Campaign: </strong>{{ '#' + cohort.details.data.id + ' - ' + cohort.details.data.name }}</li>
                                            <li v-if="cohort.details.type === 'campaign'"><strong>Recency: </strong>{{ cohort.details.data.start_date + ' - ' + cohort.details.data.end_date }}</li>
                                            <li v-if="cohort.details.type === 'audience'"><strong>Audience: </strong>{{ '#' + cohort.details.data.id + ' - ' + cohort.details.data.name }}</li>
                                        </ul>
                                    </div>
                                    <div v-if="cohort.limits">
                                        <ul class="list-unstyled mb-0">
                                            <li><strong>Limit: </strong>
                                              <span v-if="cohort.limits.type === 'devices'">
                                              <i v-if="cohort.limits.limit === 0">No Limit</i>
                                              <template v-else>
                                                {{ new Intl.NumberFormat().format(cohort.limits.limit) }} Devices
                                              </template>
                                            </span>
                                              <span v-if="cohort.limits.type === 'distance'">{{ new Intl.NumberFormat().format(cohort.limits.distance) }} {{ cohort.limits.unit }}</span>
                                                <span v-if="cohort.limits.type === 'frequency'">
                                                    <span v-if="cohort.limits.is_day_part">DayPart </span>
                                                    <span v-else>Daily </span>
                                                    <span>Freq. of {{ cohort.limits.min + ' - ' + cohort.limits.max }}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                                <td>
                                    <v-tooltip top color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <button
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="showDeleteModal(cohort)"
                                                class="btn btn-danger btn-sm">
                                                <i class="fas fa-trash"></i>
                                            </button>
                                        </template>
                                        <span>Delete Cohort</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Modal>

        <DeleteModal v-if="deleteModalDialog"></DeleteModal>
    </div>
</template>

<script>
import Modal from '../Modal'
import api from "../../api/analyses/activations";
import mixins from "../../mixin";
import DeleteModal from "../general/DeleteModal";
import TableLoading from "../general/TableLoading";
import { EventBus } from "../../events";

export default {
    name: "CohortsManagement",
    mixins: [mixins],
    components: {
        Modal,
        DeleteModal,
        TableLoading
    },
    data: () => ({
        cohorts: [],
        deletingCohort: [],
        deleteModalDialog: false,
        loading: true,
        editing_cohort: {
            id: '',
            name: '',
        },
    }),
    methods: {
        async fetchCohorts() {
            this.loading = true
            await api.getAllCohorts({})
            .then(res => {
                this.cohorts = res.data
                this.loading = false
            })
        },
        showDeleteModal(cohort) {
            this.deletingCohort = cohort
            this.deleteModalDialog = true
        },
        showAudience(cohort) {
            this.$parent.showAudience({'id': cohort.audience_id})
        },
        editCohortField(cohort) {
            this.editing_cohort.id = cohort.id
            this.editing_cohort.name = cohort.name
        },
        updateCohortName(name) {
            if (this.editing_cohort.name === name) {
                this.editing_cohort.id = ''
                this.editing_cohort.name = ''
            } else {
                this.updateItem()
            }
        },
        createNewCohort() {
            this.$parent.showNewCohortModal()
        },
        cohortActions() {
            this.$parent.showCohortActionsModal()
        },
        cancelUpdateCohortName() {
            this.editing_cohort.id = ''
            this.editing_cohort.name = ''
        },
        async updateItem() {
            await api.updateCohortName({
                id: this.editing_cohort.id,
                name: this.editing_cohort.name
            })
            .then(res => {
                this.editing_cohort.id = ''
                this.editing_cohort.name = ''
                this.fetchCohorts()
                this.$toast.open({
                    message: 'Cohort has been successfully updated',
                    type: "success",
                })
            })
            .catch(e => {
                this.editing_cohort.id = ''
                this.editing_cohort.name = ''
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
            })
        },
        async deleteItem() {
            await api.deleteCohort({
                cohort: this.deletingCohort.id,
            })
            .then(res => {
                this.deleteModalDialog = false
                this.deletingCohort = []
                this.fetchCohorts()
                this.$toast.open({
                    message: 'Cohort has been successfully removed',
                    type: "success",
                })
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
                this.deleteModalDialog = false
                this.deletingCohort = []
            })
        },
    },
    mounted() {
        this.fetchCohorts()
        EventBus.$on('newCohortCreated', () => {
            this.fetchCohorts()
        })

        window.Echo.private('cohorts-' + this.$store.getters.getCompanyId)
            .listen('Backend\\Cohorts\\FileCohortUpdated', (e) => {
                this.fetchCohorts()
            })
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>